/**
 * Mirror of `isBuildPlanFullyVerified` in @fias/builder-types (the webapp
 * cannot import the server packages). The server and the client must give
 * the SAME answer to "is this build done?" — when they differed, the browser
 * showed Refine and sent `complete` while the server stayed in `execution`
 * and kept enforcing the edit budget. Pinned to the server copy by
 * tests/architecture/builder-client-mirrors-parity.test.ts.
 *
 * A graph plan is judged by its graph nodes (`steps[]` is derived from the
 * graph); a plan without a graph, or with an empty one, by its steps. Never
 * vacuously true.
 */
import type { BuildPlan } from '../types';

export function isBuildPlanFullyVerified(
  plan: Pick<BuildPlan, 'graph' | 'steps'> | null | undefined,
): boolean {
  if (!plan) return false;
  const nodes = plan.graph?.nodes;
  if (nodes && nodes.length > 0) return nodes.every((n) => n.status === 'verified');
  return plan.steps.length > 0 && plan.steps.every((s) => s.status === 'verified');
}
